import React, { useEffect, useState } from "react";
import { Platform } from "react-native";
import * as SplashScreen from "expo-splash-screen";
import { useDispatch } from "react-redux";
import AsyncStorage from "@react-native-async-storage/async-storage";
import customAxios from "../utils/customAxios";
import { authActions } from "../store/slices/authSlice";
import { appActions } from "../store/slices/appSlice";
import i18n from "../locales/i18n";
import { router } from "expo-router";
import { View } from "react-native";

export default function Index() {
  const dispatch = useDispatch();

  // Single sequential initialization: locale → auth → navigate
  useEffect(() => {
    const init = async () => {
      try {
        // 1. Load saved language FIRST (sync before anything renders)
        try {
          const savedLocale = await AsyncStorage.getItem("appLocale");
          if (savedLocale) {
            dispatch(appActions.initializeLocale(savedLocale));
          } else {
            dispatch(appActions.initializeLocale(i18n.locale));
          }
        } catch {
          dispatch(appActions.initializeLocale(i18n.locale));
        }

        // 2. Check authentication
        const token = await AsyncStorage.getItem("accessToken");

        if (token) {
          try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 10000);

            const res = await customAxios.get("/users/check", {
              signal: controller.signal,
              _skipAuthRedirect: true,
            } as any);

            clearTimeout(timeoutId);

            dispatch(authActions.setUser(res.data.userinfo));
            dispatch(authActions.setAuthError(""));

            // 3. Navigate: authenticated user → start
            await SplashScreen.hideAsync();
            router.replace("/(drawer)/start");
            return;
          } catch {
            await AsyncStorage.removeItem("accessToken");
            try {
              const { deleteItemAsync } = await import("expo-secure-store");
              await deleteItemAsync("refreshToken");
            } catch {}

            dispatch(authActions.setUser(null));
            dispatch(authActions.setAuthError("Invalid or expired token"));
          }
        } else {
          dispatch(authActions.setUser(null));
        }

        // 3. Navigate: unauthenticated user
        dispatch(authActions.setLoading(false));
        await SplashScreen.hideAsync();

        if (Platform.OS === "web") {
          router.replace("/(routes)/(auth)/login");
        } else {
          const hasSeenOnboarding =
            await AsyncStorage.getItem("hasSeenOnboarding");
          if (hasSeenOnboarding) {
            router.replace("/(routes)/(auth)/login");
          } else {
            router.replace("/(routes)/welcome-intro");
          }
        }
      } catch {
        dispatch(authActions.setLoading(false));
        await SplashScreen.hideAsync();
        router.replace("/(routes)/(auth)/login");
      }
    };

    init();
  }, [dispatch]);

  // Render nothing — splash screen covers this
  return <View style={{ flex: 1 }} />;
}
